import script from "./DeliveryInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryInfo.vue?vue&type=style&index=0&id=ee73ac1a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee73ac1a"]])

export default __exports__